<template>
    <div></div>
</template>

<script>
    export default {
        name: "Empty",
        data: function () {
            return {}
        }
    }
</script>

<style lang="scss" scoped>

</style>